import Vue from 'vue'
import { Tabs, Table, Form, Row, Col, Input, Button, Select, message, Spin, Modal } from 'ant-design-vue'
import { FlightCitySelector } from 'ace-ui-eking'

Vue.use(Tabs)
Vue.use(Table)
Vue.use(Form)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(Select)
Vue.use(Spin)
Vue.use(Modal)
Vue.use(FlightCitySelector)
Vue.prototype.$message = message
Vue.prototype.$modal = Modal
Vue.prototype.$error = Modal.error
